import { Member, PublicPrefillData } from "@flow/common/types";
import { EmailInput } from "@flow/frontend/member/components/EmailInput";
import { PostcodeInput } from "@flow/frontend/member/components/PostcodeInput";
import { TextArea } from "@flow/frontend/member/components/TextArea";
import { memberTheme } from "@flow/frontend/member/memberTheme";
import { Link, Paper, lighten } from "@mui/material";
import React from "react";
import { OptionalTextArea } from "./OptionalTextArea";

export function SendAMessageContactForm(props: {
  useMemberPrefill: boolean;
  onRejectPrefill: (_: React.MouseEvent) => void;
  redactedPrefill: PublicPrefillData | undefined;
  isStaff: boolean;
  takenAction: boolean;
  member: Member;
  onMemberChange: (_: Member) => void;
}) {
  const { member, onMemberChange } = props;
  return (
    <>
      {props.redactedPrefill && props.useMemberPrefill ? (
        <Paper elevation={0} sx={{ backgroundColor: lighten(memberTheme.palette.error.main, 0.85), padding: "1rem" }}>
          You&#39;re sending this as <strong>{props.redactedPrefill.name}</strong>. Not you?{" "}
          <Link
            onClick={props.onRejectPrefill}
            color="inherit"
            sx={{
              textDecoration: "underline",
              "&:hover": { textDecoration: "underline", color: "inherit", cursor: "pointer" },
            }}
          >
            Click here
          </Link>
        </Paper>
      ) : (
        <>
          {props.isStaff && props.takenAction && (
            <Paper
              elevation={0}
              sx={{ backgroundColor: lighten(memberTheme.palette.error.main, 0.85), padding: "1rem" }}
            >
              38 Degrees Staff: <br />
              You have already taken this action so we have not prefilled your details
            </Paper>
          )}
          <TextArea value={member.name} onChange={(value) => onMemberChange({ ...member, name: value })} label="Name" />
          <EmailInput
            value={member.email}
            onChange={(value) => onMemberChange({ ...member, email: value })}
            label="Email"
          />
        </>
      )}

      <TextArea
        value={member.line1}
        onChange={(value) => onMemberChange({ ...member, line1: value })}
        label="Address"
      />
      <OptionalTextArea
        value={member.town}
        onChange={(value) => onMemberChange({ ...member, town: value })}
        label="Town"
      />
      <PostcodeInput
        value={member.postcode}
        onChange={(value) => onMemberChange({ ...member, postcode: value })}
        label="Postcode"
        sx={{ marginBottom: "0" }}
      />
    </>
  );
}
